module.exports = __webpack_public_path__ + "img/shop-profit.9ebfb141.png";